<template>
    <div :id="`global-catalog-template-card-${template.id}`" class="flex flex-col border rounded-lg p-3 hover:shadow-md transition bg-[#fff] text-[#171717] h-full">
        <div class="flex-1 flex flex-col gap-4">
            <img :id="`global-catalog-template-image-${template.id}`" :src="template.image" alt="logo" class="h-13 max-w-19 mx-auto" />
            <div class="font-semibold text-base text-[#171717]">{{ template.title }}</div>
            <ul class="list-disc ml-3 space-y-2 text-[#171717] text-sm">
                <li v-for="name in visibleProducts">
                    {{ name }}
                </li>
            </ul>
        </div>

        <div class="mt-auto pt-3 flex items-center gap-2"
            :class="productNames.length > 5 ? 'justify-between' : 'justify-center'">
            <div v-if="productNames.length > 5"
              :id="`global-catalog-template-toggle-${template.id}`"
              class="flex items-center text-[#171717] md:ml-2 text-base cursor-pointer select-none"
              @click="$emit('toggleExpanded')">
                <span>{{ props.isExpanded ? $t('catalog.less') : $t('global.more') }}</span>
                <i class="text-lg ri-arrow-down-s-line transition-transform"
                    :class="{'rotate-180' : props.isExpanded}"></i>
            </div>

            <BaseButton size="custom" :id="`global-catalog-template-select-${template.id}`" class="py-1 px-3.5 !rounded text-base"
              @click="setSelectedTemplates(template)">
              {{ $t('global.select') }}
            </BaseButton>
        </div>
    </div>
</template>

<script setup>
import { useGlobalCatalogStore } from '@/stores/globalCatalogStore';
import { computed, ref } from 'vue';
import BaseButton from '@/components/atoms/buttons/BaseButton.vue';

const globalCatalogStore = useGlobalCatalogStore();

const props = defineProps({
    template: {
        type: Object,
        default: {}
    },
    isExpanded: {
        type: Boolean,
        default: false
    }
})
const setSelectedTemplates = template => {
  globalCatalogStore.selectedTemplates.push(template)
}

const productNames = computed(() => {
    const productNamesArray = [];

    if (props.template?.items?.length) {
      props.template.items.forEach((item, index) => {
        if (!item.ItemOptions) return;
        try {
          const parsed = JSON.parse(item.ItemOptions || '{}');
          if (parsed.ProductWebName) {
            productNamesArray.push(parsed.ProductWebName);
          }
        } catch (err) {
          console.warn(`Error parsing ItemOptions for ${template.title}`, err);
        }
      });
    }
    return productNamesArray;
});

const visibleProducts = computed(() => props.isExpanded ? productNames.value : productNames.value.slice(0, 5));
</script>